import { ResponsiveImage } from '@/components/media/responsive-image';

type AppImageProps = {
  src: string;
  alt: string;
  className?: string;
  fill?: boolean;
  sizes?: string;
  priority?: boolean;
  width?: number;
  height?: number;
};

export function AppImage({
  src,
  alt,
  className,
  fill = false,
  sizes,
  priority,
  width,
  height,
}: AppImageProps) {
  return (
    <ResponsiveImage
      src={src}
      alt={alt}
      fill={fill}
      sizes={sizes}
      priority={priority}
      width={width}
      height={height}
      className={className}
    />
  );
}
